import {
  DataGridPremium,
  DataGridPremiumProps,
  gridClasses,
  isAutogeneratedRow,
} from "@mui/x-data-grid-premium";
import { styled } from "@mui/material/styles";

const StyledDataGrid = styled(DataGridPremium)(({ theme }) => ({
  border: "none",
  backgroundColor: theme.palette.background.paper,

  [`& .${gridClasses.columnHeaders}`]: {
    backgroundColor: "#F1F5F9",
  },

  [`& .${gridClasses.columnHeaderTitle}`]: {
    fontWeight: 600,
  },

  [`& .${gridClasses.row}:hover`]: {
    backgroundColor: "#F8FAFC",
  },

  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.action.hover,
  },

  [`& .${gridClasses.row}.row-overdue`]: {
    backgroundColor: "rgba(244, 67, 54, 0.06)",
    borderLeft: "4px solid #d32f2f",
  },

  [`& .${gridClasses.row}.row-autogenerated`]: {
    cursor: "default",
    fontWeight: 600,
    backgroundColor: `${theme.palette.background.paper} !important`,
  },

  [`& .${gridClasses.row}.row-autogenerated:hover`]: {
    backgroundColor: `${theme.palette.background.paper} !important`,
  },

  [`& .${gridClasses.row}.row-autogenerated .${gridClasses.cell}`]: {
    backgroundColor: `${theme.palette.background.paper} !important`,
  },
}));

export default function StripedDataGrid(props: DataGridPremiumProps) {
  const { getRowClassName, ...other } = props;

  return (
    <StyledDataGrid
      {...other}
      getRowClassName={(params) => {
        const customClass = getRowClassName ? getRowClassName(params) : "";

        if (isAutogeneratedRow(params.row)) {
          return `row-autogenerated ${customClass}`.trim();
        }

        const stripeClass =
          params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd";

        return `${stripeClass} ${customClass}`.trim();
      }}
    />
  );
}